"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StateReducer = exports.SendAnalytics = exports.QuizState = exports.QuizDispatch = exports.Methods = exports.GetTestIds = void 0;
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _QuizProvider = require("./QuizProvider");
var _classnames = _interopRequireDefault(require("classnames"));
var _analytics = require("../../utils/analytics");
var _array = require("../../utils/type-checks/array");
var _boolean = require("../../utils/type-checks/boolean");
var _number = require("../../utils/type-checks/number");
var _object = require("../../utils/type-checks/object");
var _react = _interopRequireWildcard(require("react"));
var _string = require("../../utils/type-checks/string");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge"),
  QuizCustomTheme = /*#__PURE__*/(0, _react.createContext)(null),
  QuizState = exports.QuizState = /*#__PURE__*/(0, _react.createContext)(null),
  QuizDispatch = exports.QuizDispatch = /*#__PURE__*/(0, _react.createContext)(null),
  GetTestIds = testId => {
    return {
      component: (0, _string.isStringOfLength)(testId) ? testId : undefined,
      form: (0, _string.isStringOfLength)(testId) ? `${testId}__form` : undefined
    };
  },
  SendAnalytics = (quizName, quizEvent) => {
    let result = false;
    if ((0, _string.isStringOfLength)(quizName) && (0, _string.isStringOfLength)(quizEvent)) {
      (0, _analytics.createEventGA4)(`${quizEvent}:${quizName}`);
      result = true;
    }
    return result;
  },
  StateReducer = (state, action) => {
    const resetStateObj = {},
      workingState = merge({}, state);
    let boolToggle = false,
      result = {
        ...workingState
      };
    Object.keys(workingState.formState).forEach(key => resetStateObj[key] = (0, _string.isString)(workingState.formState[key]) ? "" : false);
    switch (action.type) {
      case "jumpToModalPanel":
        result = {
          ...workingState,
          isCompleted: false,
          isModalOpen: true,
          isReset: true,
          panelIndex: (0, _number.isNumber)(action.panelIndex) ? action.panelIndex : 0
        };
        break;
      case "navigateNameSkip":
        result = {
          ...workingState,
          formState: {
            ...workingState.formState,
            firstName: ""
          },
          panelIndex: workingState.panelIndex + 1
        };
        break;
      case "navigatePanelBack":
        result = {
          ...workingState,
          panelIndex: workingState.panelIndex - 1,
          direction: -1
        };
        break;
      case "navigatePanelForward":
        result = {
          ...workingState,
          panelIndex: workingState.panelIndex + 1,
          direction: 1
        };
        break;
      case "resetState":
        result = {
          ...workingState,
          formState: resetStateObj,
          isCompleted: false,
          isModalOpen: true,
          isReset: true,
          panelIndex: 0,
          direction: 1
        };
        break;
      case "setForm":
        if ((0, _object.isObject)(action.formState)) {
          result = {
            ...workingState,
            formState: action.formState
          };
        }
        break;
      case "setData":
        result = {
          ...workingState
        };
        if ((0, _array.isArrayOfLength)(action.array)) {
          action.array.forEach(obj => {
            if ((0, _string.isStringOfLength)(obj.name)) {
              result.data[obj.name] = obj.value;
            }
          });
        } else if ((0, _object.isObject)(action.data)) {
          result.data = {
            ...action.data
          };
        } else if ((0, _string.isStringOfLength)(action.name)) {
          result.data[action.name] = action.value;
        }
        break;
      case "toggleCompletion":
        boolToggle = (0, _boolean.isBoolean)(action.value) ? action.value : !workingState.isCompleted;
        if (boolToggle === true) {
          result = {
            ...workingState,
            isCompleted: boolToggle,
            isModalOpen: false
          };
        } else {
          result = {
            ...workingState,
            isCompleted: boolToggle
          };
        }
        break;
      case "toggleModal":
        boolToggle = (0, _boolean.isBoolean)(action.value) ? action.value : !workingState.isModalOpen;
        if (boolToggle === true) {
          result = {
            ...workingState,
            isModalOpen: boolToggle
          };
        } else {
          result = {
            ...workingState,
            formState: resetStateObj,
            isCompleted: false,
            isModalOpen: boolToggle,
            isReset: true,
            panelIndex: 0
          };
        }
        break;
      case "toggleReset":
        result = {
          ...workingState,
          isReset: !workingState.isReset
        };
        break;
      case "updateForm":
        if ((0, _string.isStringOfLength)(action.name) && ((0, _string.isString)(action.value) || (0, _boolean.isBoolean)(action.value))) {
          result = {
            ...workingState,
            formState: {
              ...workingState.formState,
              [`${action.name}`]: action.value
            }
          };
        }
        break;
      default:
        result = {
          ...workingState
        };
        break;
    }
    return result;
  },
  Methods = exports.Methods = {
    GetTestIds: GetTestIds,
    sendAnalytics: SendAnalytics,
    stateReducer: StateReducer,
    useCustomTheme: () => (0, _react.useContext)(QuizCustomTheme),
    useDispatch: () => (0, _react.useContext)(QuizDispatch),
    useState: () => (0, _react.useContext)(QuizState)
  };

/**
 * Form and State Management for Quiz Views
 *
 * @visibleName Quiz Provider
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.StateReducer = StateReducer;
exports.SendAnalytics = SendAnalytics;
exports.GetTestIds = GetTestIds;
const QuizProvider = props => {
  const {
      children,
      className,
      component = "article",
      customData = {},
      customTheme = {},
      defaultIsCompleted = false,
      defaultIsModalOpen = false,
      defaultIsReset = false,
      formState,
      name = "quiz_form",
      novalidate = true,
      panelIndex = 0,
      styles,
      testId
    } = props,
    [state, dispatch] = (0, _react.useReducer)(_QuizProvider.Methods.stateReducer, {
      data: customData,
      isCompleted: defaultIsCompleted,
      isModalOpen: defaultIsModalOpen,
      isReset: defaultIsReset,
      formState: {
        firstName: "",
        ...formState
      },
      panelIndex: panelIndex,
      direction: 1
    }),
    customClasses = (0, _classnames.default)({
      "quiz": true,
      [`${className}`]: className
    }),
    testIdObject = (0, _react.useMemo)(() => _QuizProvider.Methods.GetTestIds(testId), [testId]);
  (0, _react.useEffect)(() => {
    if (state.isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [state.isModalOpen]);
  return /*#__PURE__*/_react.default.createElement(QuizCustomTheme.Provider, {
    value: customTheme
  }, /*#__PURE__*/_react.default.createElement(QuizDispatch.Provider, {
    value: dispatch
  }, /*#__PURE__*/_react.default.createElement(QuizState.Provider, {
    value: state
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: customClasses,
    component: component,
    "data-testid": testIdObject.component,
    sx: styles
  }, novalidate ? /*#__PURE__*/_react.default.createElement("form", {
    "data-testid": testIdObject.form,
    name: name,
    noValidate: true
  }, children) : /*#__PURE__*/_react.default.createElement("form", {
    "data-testid": testIdObject.form,
    name: name
  }, children)))));
};

// Define propTypes;
QuizProvider.propTypes = {
  /** Quiz child contents */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  /** Custom className */
  className: _propTypes.default.string,
  /** Component tag (Default Value: "article") */
  component: _propTypes.default.string,
  /** Custom Name/Value Hash Data Store (Default Value: {}) */
  customData: _propTypes.default.object,
  /** Custom Theme Object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Boolean to default the quiz into a completed state (Default Value: false) */
  defaultIsCompleted: _propTypes.default.bool,
  /** Boolean to default the quiz with the modal window open (Default Value: false) */
  defaultIsModalOpen: _propTypes.default.bool,
  /** @ignore */
  defaultIsReset: _propTypes.default.bool,
  /** Initial object of name/values for form */
  formState: _propTypes.default.object.isRequired,
  /** String to be output (Default Value: "quiz_form") */
  name: _propTypes.default.string,
  /** Boolean to turn on/off constraint validation (Default Value: true) */
  novalidate: _propTypes.default.bool,
  /** Panel to open to when modal launches (Default Value: 0) */
  panelIndex: _propTypes.default.number,
  /** Test ID String */
  testId: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = QuizProvider;